import React from 'react'

export default function Countriesdetailshimmer() {
  return (
    <div className='country-details'>
        <img className='shim-card' />
        <div className='details-text-container'>
            <div className='shimmerheading'></div>
            <div className='shimmerdesc'></div>
        </div>
    </div>
  )
}
